// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Tooltip-module__tooltip___VdwQ6","tooltip__reference":"Tooltip-module__tooltip__reference___3c3eT","tooltip__arrow":"Tooltip-module__tooltip__arrow___2pnHh"};